import { cva } from 'class-variance-authority';
import styles from '../styles.module.scss';

export const cellVariants = cva(styles.cell, {
  variants: {
    size: {
      default: styles.sizeDefault,
      md: styles.sizeMd,
      lg: styles.sizeLg,
    },
    align: {
      left: styles.alignLeft,
      center: styles.alignCenter,
      right: styles.alignRight,
    },
  },
  defaultVariants: {
    size: 'default',
    align: 'left',
  },
});
